import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import FrequencyForm from "./FrequencyForm";
import HelpButton from "../HelpContent/HelpButton";

export default function HttpRequest200to399({
  monitor,
  check,
  setCheck,
  checkType,
  selectedApiDetails,
}) {
  return (
    check && (
      <div className="align-items-center rounded-3  p-4 bg-purple-gradient-darker-reverse px-5  mx-auto">
        <div className="row">
          <div className="mb-3">
            <span className="fs-4 fw-bold text-capitalize ">
              {checkType === "liveness" ? "Status" : "Recovery"} Check
              Configuration
              <HelpButton helpKey={`monitoring-${checkType}-check`} />
            </span>
          </div>
          <div className="">
            <Form.Group className="mb-3" controlId="monitorTitle">
              <Form.Label className="fw-bold">Request path:</Form.Label>
              <InputGroup>
                {selectedApiDetails?.Profile?.BaseUrl && (
                  <InputGroup.Text id="basic-addon3">
                    {selectedApiDetails.Profile.BaseUrl}
                  </InputGroup.Text>
                )}
                <Form.Control
                  type="text"
                  placeholder="/health"
                  value={check.Path}
                  onChange={(e) => setCheck({ ...check, Path: e.target.value })}
                />
              </InputGroup>
              <div>
                <span className="text-secondary">
                  The destination for this check is:
                </span>
                <span className="fw-bold"> {monitor.selectedApiBaseUrl}</span>
              </div>
            </Form.Group>
          </div>
        </div>
        <div>
          <FrequencyForm
            monitor={monitor}
            check={check}
            setCheck={setCheck}
            checkType={checkType}
          />
        </div>
      </div>
    )
  );
}
